import { Space, Typography, Card, List, Avatar, Spin, Alert } from 'antd';
import { UserOutlined, WalletOutlined, SoundOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { formatMoney } from '../utils';
import { useDashboardTransactions } from '../hooks/useDashboardQueries';

const { Text } = Typography;

export const RecentTransactions = ({ dateRange }: any) => {
    const navigate = useNavigate();

    const params = {
        startDate: dateRange?.[0]?.format('YYYY-MM-DD'),
        endDate: dateRange?.[1]?.format('YYYY-MM-DD'),
        timezone: 'Asia/Kolkata',
        limit: 5
    };

    const { data: response, isLoading, isError } = useDashboardTransactions(params);

    if (isLoading) return <Card title="Recent Transactions" style={{ height: '100%' }}><Spin size="large" style={{ display: 'block', margin: 'auto', marginTop: 50 }} /></Card>;
    if (isError) return <Alert type="error" message="Failed to load transactions" />;

    const transactions = response?.data || [];

    return (
        <Space direction="vertical" size="middle" style={{ width: '100%' }}>
            <Card title="Recent Transactions" extra={<a href="#" onClick={(e) => { e.preventDefault(); navigate('/payments'); }}>View All</a>} styles={{ body: { padding: '0 16px' } }}>
                <List
                    rowKey="id"
                    itemLayout="horizontal"
                    dataSource={transactions}
                    renderItem={(item: any) => (
                        <List.Item style={{ padding: '12px 0' }}>
                            <List.Item.Meta
                                avatar={
                                    <Avatar icon={item.type === 'SPONSORED_AD' ? <SoundOutlined /> : (item.direction === 'CREDIT' ? <WalletOutlined /> : <UserOutlined />)} style={{ backgroundColor: item.type === 'SPONSORED_AD' ? '#fff0f6' : (item.direction === 'CREDIT' ? '#e6f7ff' : '#fff1f0'), color: item.type === 'SPONSORED_AD' ? '#eb2f96' : (item.direction === 'CREDIT' ? '#1890ff' : '#ff4d4f') }} />
                                }
                                title={<Text style={{ fontSize: 13 }}>{item.merchantName}</Text>}
                                description={<Text type="secondary" style={{ fontSize: 11 }}>{item.type.replace('_', ' ')} • {item.reference?.id}</Text>}
                            />
                            <div style={{ textAlign: 'right' }}>
                                <div style={{ color: item.direction === 'CREDIT' ? '#52c41a' : '#ff4d4f', fontSize: 13, fontWeight: 500 }}>
                                    {item.direction === 'CREDIT' ? '+' : '-'} ₹ {formatMoney(item.amount)}
                                </div>
                                <Text type="secondary" style={{ fontSize: 11 }}>{new Date(item.createdAt).toLocaleDateString()}</Text>
                            </div>
                        </List.Item>
                    )}
                />
            </Card>
        </Space>
    );
};
